<form [formGroup]="form">
  <div class="flex align-items-center gap-2 mb-2">
    <p-checkbox
      formControlName="termsOfService"
      [binary]="true"
      inputId="termsOfService"
      (onChange)="onTermsOfServiceChange($event)"
      (onBlur)="onTermsOfServiceBlur()"
    />
    <label for="termsOfService"
      >He leído y acepto los
      <a
        target="_blank"
        href="sitio/politicas/terminos-condiciones"
        class="font-medium text-blue-500 underline"
        rel="nofollow"
        >términos y condiciones</a
      >.
    </label>
  </div>
</form>
